// import * as React from "react";

// //imports from material ui library
// import { Box, Modal, Tooltip } from "@mui/material";

// //icon for closing the modal form
// import CancelPresentationIconButton from "../../../common/components/Buttons/CancelPresentationIconButton";

// import SearchDropdown from "../../../common/components/FormFields/searchDropdown";

// import { useForm } from "react-hook-form";

// import DatePickerFieldNew from "../../../common/components/FormFields/DatePickerFieldNew";

// import CommonButton from "../../../common/components/Buttons/CommonButton";

// import CommonBackDrop from "../../../common/components/CommonBackDrop/CommonBackDrop";

// import {
//   getBillEditPrint,
//   getBillPrint,
//   getPatientBillList,
//   searchPatientForBillList,
// } from "../../services/BillingServices";

// import CommonPrintModal from "../../../common/components/printModal/CommonPrintModal";

// import CommonDynamicTablePaginationNew from "../../../common/components/CommonTable/CommonDynamicTablePaginationNew";

// import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";

// import { useLocation } from "react-router-dom";
// import ReasonForBillCancellation from "./ReasonForBillCancellation";

// import { fetchUserActionsByMenuId } from "../../../commonServices/functionalityServices/FunctionalityServices";

// import { CancelOnIcon } from "./../../../assets/icons/CustomIcons";
// import EmbedCommonPrintModal from "../../../common/components/printModal/EmbedCommonPrintModal";

// const ModalStyle = {
//   position: "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: "95%",
//   // height: "80%",
//   overflowY: "scroll",
//   overflowX: "scroll",
//   bgcolor: "background.paper",
//   border: "1px solid gray",
//   boxShadow: 20,
//   p: 2,
// };

// export default function BillListingModal(props) {
//   const location = useLocation();
//   const defaultValues = {
//     opdbillingSearch: null,
//     FromDate: new Date(),
//     ToDate: new Date(),
//   };

//   const { control, getValues, setValue, register, watch } = useForm({
//     mode: "onChange",
//     defaultValues,
//   });

//   //Below are the props required for the
//   //CommonDynamicTablePagination component
//   //--------------------------------------------------------------------------------

//   const [userActions, setUserActions] = React.useState(null);

//   const [count, setCount] = React.useState();

//   const [page, setPage] = React.useState(0);

//   const [dataResult, setDataResult] = React.useState([]);

//   const [searchString, setSearchString] = React.useState("");

//   //State variable to get the page size from the child component.
//   const [rowsPerPage, setRowsPerPage] = React.useState(10);

//   const [openPrintModal, setOpenPrintModal] = React.useState(false);

//   const [openEditPrintModal, setOpenEditPrintModal] = React.useState(false);

//   const [urlforPrint, setUrlforPrint] = React.useState();

//   const [billCancellationModal, setBillCancellationModal] =
//     React.useState(false);

//   const [billId, setBillId] = React.useState(null);

//   //state variable to display OR to not display the CommonBackDrop component.
//   const [openBackdrop, setOpenBackdrop] = React.useState(false);

//   const handleCloseEditPrintModal = () => {
//     setOpenEditPrintModal(false);
//   };

//   const handleOpenEditPrintModal = () => {
//     setOpenEditPrintModal(false);
//   };

//   //function to return the date in yyyy-MM-DD format
//   function getRequiredDateVal(inputDateVal) {
//     let requiredDate = null;

//     let objectDate = new Date(inputDateVal);

//     let day = String(objectDate.getDate());

//     if (day.length === 1) {
//       day = `0${day}`;
//     }

//     let month = objectDate.getMonth();

//     month = month + 1;

//     month = String(month);

//     if (month.length === 1) {
//       month = `0${month}`;
//     }

//     let year = objectDate.getFullYear();

//     requiredDate = `${year}-${month}-${day}`;

//     if (requiredDate.length === 10) {
//       return requiredDate;
//     } else {
//       return null;
//     }
//   }

//   //populate the CommonMasterTable using the function populateTable
//   const populateTable = (forPagination) => {
//     let patientInfoObj = getValues("opdbillingSearch");

//     let patientIdVal = 0;

//     if (patientInfoObj) {
//       patientIdVal = patientInfoObj.id;
//     }

//     let searchObj = {
//       patientId: patientIdVal,
//       fromDate: null,
//       opdIpd: 0,
//       page: !forPagination ? 0 : page,
//       searchString: searchString,
//       size: rowsPerPage,
//       toDate: null,
//     };

//     let fromDateValue = getValues("FromDate");

//     let toDateValue = getValues("ToDate");

//     fromDateValue = getRequiredDateVal(fromDateValue);

//     toDateValue = getRequiredDateVal(toDateValue);

//     if (fromDateValue) {
//       let d = new Date(fromDateValue);
//       d = d.toISOString();
//       searchObj.fromDate = d;
//     }

//     if (toDateValue) {
//       let d = new Date(toDateValue);
//       d = d.toISOString();
//       searchObj.toDate = d;
//     }

//     getPatientBillList(searchObj)
//       .then((response) => response.data)
//       .then((res) => {
//         if (forPagination) {
//           setDataResult((prevData) => [...prevData, ...res.result]);
//         } else {
//           setPage(0);
//           setDataResult(res.result);
//         }
//         setCount(res.count);
//       })
//       .catch((error) => {});
//   };

//   //------------------------------------------------------------------------------------

//   const handleClosePrintModal = () => {
//     setOpenPrintModal(false);
//   };

//   const handleOpenPrintModal = (billIdVal, type) => {
//     setOpenBackdrop(true);
//     if (type === "view") {
//       getBillPrint(billIdVal)
//         .then((response) => {
//           setOpenBackdrop(false);
//           setOpenPrintModal(true);
//           setUrlforPrint(response);
//         })
//         .catch(() => {
//           setOpenBackdrop(false);
//         });
//     } else if (type === "edit") {
//       getBillEditPrint(billIdVal)
//         .then((response) => {
//           setOpenBackdrop(false);
//           setOpenEditPrintModal(true);
//           setUrlforPrint(response);
//         })
//         .catch(() => {
//           setOpenBackdrop(false);
//         });
//     }
//   };

//   //Below is the renderActions function
//   const renderActions = (row, index) => {
//     // #4b5563
//     return (
//       <div className="flex items-center	justify-start gap-1 ">
//         {userActions &&
//           userActions.map((singleActionObj) => (
//             <>
//               {singleActionObj.action === "Print" &&
//               singleActionObj.isAction === true ? (
//                 <>
//                   <Tooltip title="Print Bill Receipt">
//                     <LocalPrintshopIcon
//                       sx={
//                         row.IsCancelled === true
//                           ? { color: "#71797E" }
//                           : { color: "#4B5563" }
//                       }
//                       onClick={() => {
//                         let billId = row.BillId;

//                         if (row.IsCancelled === false) {
//                           handleOpenPrintModal(billId, "view");
//                         }
//                       }}
//                     />
//                   </Tooltip>
//                 </>
//               ) : (
//                 ""
//               )}

//               {singleActionObj.action === "Edit Print" &&
//               singleActionObj.isAction === true ? (
//                 <>
//                   <Tooltip title="Edit Print">
//                     <LocalPrintshopIcon
//                       sx={
//                         row.IsCancelled === true
//                           ? { color: "#71797E" }
//                           : { color: "#FA5332" }
//                       }
//                       onClick={() => {
//                         let billId = row.BillId;
//                         if (row.IsCancelled === false) {
//                           handleOpenPrintModal(billId, "edit");
//                         }
//                       }}
//                     />
//                   </Tooltip>
//                 </>
//               ) : (
//                 ""
//               )}

//               {singleActionObj.action === "Cancel" &&
//               singleActionObj.isAction === true ? (
//                 <>
//                   <CancelOnIcon
//                     title="Cancel Bill"
//                     onClick={() => {
//                       let billIdVal = row.BillId;

//                       if (row.IsCancelled === false) {
//                         setBillId(billIdVal);
//                         setBillCancellationModal(true);
//                       }
//                     }}
//                   />
//                 </>
//               ) : (
//                 ""
//               )}
//             </>
//           ))}
//       </div>
//     );
//   };

//   //---------------------------------------------

//   //state variable to populate the "opdbillingSearch" SearchDropdown
//   const [options, setOptions] = React.useState([]);

//   React.useEffect(() => {
//     let patientInfoObj = getValues("opdbillingSearch");

//     let patientIdVal = 0;

//     if (patientInfoObj) {
//       patientIdVal = patientInfoObj.id;
//     }

//     let searchObj = {
//       patientId: patientIdVal,
//       fromDate: new Date(),
//       opdIpd: 0,
//       page: 0,
//       searchString: searchString,
//       size: rowsPerPage,
//       toDate: new Date(),
//     };

//     getPatientBillList(searchObj)
//       .then((response) => {
//         let tempObj = {};
//         tempObj.result = response.data.result;
//         tempObj.statusCode = response.data.statusCode;
//         setCount(response.data.count);
//         setDataResult(response.data.result);
//       })
//       .catch((error) => {});

//     fetchUserActionsByMenuId(
//       props.menuId ? props.menuId : location?.state?.menuId
//     )
//       .then((response) => response.data)
//       .then((res) => {
//         setUserActions(res.result);
//       });
//   }, []);

//   //Change handler for "Search By Patient Name / MR No" SearchDropdown.
//   const handleChange = (searchString) => {
//     let patientObjForBillSearch = {
//       fromDate: null,
//       opdIpd: 0,
//       searchString: searchString,
//       toDate: null,
//     };

//     setSearchString(searchString);

//     let FromDateVal = getValues("FromDate");
//     let ToDateVal = getValues("ToDate");

//     FromDateVal = getRequiredDateVal(FromDateVal);

//     ToDateVal = getRequiredDateVal(ToDateVal);

//     if (FromDateVal) {
//       let d = new Date(FromDateVal);
//       d = d.toISOString();
//       patientObjForBillSearch.fromDate = d;
//     }

//     if (ToDateVal) {
//       let d = new Date(ToDateVal);
//       d = d.toISOString();
//       patientObjForBillSearch.toDate = d;
//     }

//     if (searchString !== "") {
//       searchPatientForBillList(patientObjForBillSearch).then((response) => {
//         setOptions(response.data.result);
//       });
//     }
//   };

//   return (
//     <>
//       <div>
//         <Modal
//           open={props.open}
//           aria-labelledby="modal-modal-title"
//           aria-describedby="modal-modal-description"
//         >
//           <Box sx={ModalStyle}>
//             <div className="grid md:grid-cols-1  w-full">
//               <CancelPresentationIconButton
//                 onClick={() => {
//                   props.setOpen(false);
//                 }}
//                 style={{
//                   paddingLeft: 10,
//                 }}
//               />
//             </div>

//             <div className="row">
//               <fieldset className="border border-gray-300 text-left  lg:mx-auto lg:px-4 lg:m-2  md:ml-0 md:mr-0  rounded   ">
//                 <legend className="md:mx-2 md:px-2 lg:px-2 font-bold text-gray-700">
//                   Bill List
//                 </legend>

//                 <div className="grid lg:grid-cols-5 gap-2 md:grid-cols-2 md:p-5 items-center">
//                   {/* SearchDropdown field for taking the patient name's string.*/}
//                   <div className="lg:col-span-2 lg:w-[95%] md:w-[95%] md:col-span-1">
//                     <SearchDropdown
//                       control={control}
//                       name="opdbillingSearch"
//                       dataArray={options}
//                       searchIcon={true}
//                       isClearable={true}
//                       isSearchable={true}
//                       placeholder="Search By Patient Name / MR.No./ Mobile No."
//                       handleInputChange={handleChange}
//                       inputRef={{
//                         ...register("opdbillingSearch", {
//                           onChange: (e) => {},
//                         }),
//                       }}
//                     />
//                   </div>

//                   {/* This is the div for date picker */}
//                   <div>
//                     <DatePickerFieldNew
//                       name="FromDate"
//                       control={control}
//                       label="From Date"
//                       value={new Date()}
//                       onChange={(newValue) => {
//                         setValue("FromDate", newValue);
//                       }}
//                       inputFormat="dd-MM-yyyy"
//                     />
//                   </div>

//                   {/* This is the div for date picker. */}
//                   <div>
//                     <DatePickerFieldNew
//                       name="ToDate"
//                       control={control}
//                       label="To Date"
//                       value={new Date()}
//                       onChange={(newValue) => {
//                         setValue("ToDate", newValue);
//                       }}
//                       inputFormat="dd-MM-yyyy"
//                     />
//                   </div>

//                   {/* This is the div for SearchIcon button. */}
//                   <div>
//                     <CommonButton
//                       // label="Search Icon"
//                       searchIcon
//                       className="bg-customBlue text-white"
//                       onClick={() => {
//                         populateTable();
//                       }}
//                     />
//                   </div>
//                 </div>
//               </fieldset>

//               {dataResult.length > 0 ? (
//                 <>
//                   <CommonDynamicTablePaginationNew
//                     dataResult={dataResult}
//                     renderActions={renderActions}
//                     populateTable={populateTable}
//                     page={page}
//                     setPage={setPage}
//                     rowsPerPage={rowsPerPage}
//                     count={count}
//                     tableClass={"rounded lg:h-72 2xl:h-96"}
//                     removeHeaders={[
//                       "BillId",
//                       "IsCancelled",
//                       "BillNo",
//                       "PatientId",
//                     ]}
//                     // RenderButtons={RenderButtons}
//                   />
//                 </>
//               ) : (
//                 <>
//                   <div className="text-center mt-10">No Record Found</div>
//                 </>
//               )}
//             </div>
//           </Box>
//         </Modal>

//         {/* backdrop */}
//         <CommonBackDrop openBackdrop={openBackdrop} />

//         {openPrintModal ? (
//           <CommonPrintModal
//             open={openPrintModal}
//             setOpen={setOpenPrintModal}
//             handleOpen={handleOpenPrintModal}
//             handleClose={handleClosePrintModal}
//             urlforPrint={urlforPrint}
//           />
//         ) : null}

//         {openEditPrintModal ? (
//           <EmbedCommonPrintModal
//             open={openEditPrintModal}
//             setOpen={setOpenEditPrintModal}
//             handleOpen={handleOpenEditPrintModal}
//             handleClose={handleCloseEditPrintModal}
//             urlforPrint={urlforPrint}
//           />
//         ) : null}

//         {billCancellationModal ? (
//           <ReasonForBillCancellation
//             open={billCancellationModal}
//             setOpen={setBillCancellationModal}
//             billId={billId}
//             populateTable={populateTable}
//           />
//         ) : null}
//       </div>
//     </>
//   );
// }


import * as React from "react";

import { Box, Modal, Tooltip } from "@mui/material";

import CancelPresentationIconButton from "../../../common/components/Buttons/CancelPresentationIconButton";
import SearchDropdown from "../../../common/components/FormFields/searchDropdown";
import DatePickerFieldNew from "../../../common/components/FormFields/DatePickerFieldNew";
import CommonButton from "../../../common/components/Buttons/CommonButton";
import CommonBackDrop from "../../../common/components/CommonBackDrop/CommonBackDrop";

import { useForm } from "react-hook-form";

import {
  getBillEditPrint,
  getBillPrint,
  getPatientBillList,
  searchPatientForBillList,
} from "../../services/BillingServices";

import CommonPrintModal from "../../../common/components/printModal/CommonPrintModal";
import CommonDynamicTablePaginationNew from "../../../common/components/CommonTable/CommonDynamicTablePaginationNew";

import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";

import { useLocation } from "react-router-dom";

import ReasonForBillCancellation from "./ReasonForBillCancellation";

import { fetchUserActionsByMenuId } from "../../../commonServices/functionalityServices/FunctionalityServices";

import { CancelOnIcon } from "./../../../assets/icons/CustomIcons";

import EmbedCommonPrintModal from "../../../common/components/printModal/EmbedCommonPrintModal";

const ModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: {
    xs: "98%",
    sm: "96%",
    md: "94%",
    lg: "92%",
  },
  maxWidth: "1600px",
  height: {
    xs: "96dvh",
    sm: "92dvh",
    md: "90dvh",
  },
  maxHeight: "96dvh",
  overflowY: "auto",
  overflowX: "hidden",
  bgcolor: "background.paper",
  border: "1px solid #d1d5db",
  borderRadius: "8px",
  boxShadow: 20,
  p: {
    xs: 1,
    sm: 1.5,
    md: 2,
  },
};

export default function BillListingModal(props) {
  const location = useLocation();

  const defaultValues = {
    opdbillingSearch: null,
    FromDate: new Date(),
    ToDate: new Date(),
  };

  const { control, getValues, setValue, register } = useForm({
    mode: "onChange",
    defaultValues,
  });

  const [userActions, setUserActions] = React.useState(null);
  const [count, setCount] = React.useState(0);
  const [page, setPage] = React.useState(0);
  const [dataResult, setDataResult] = React.useState([]);
  const [searchString, setSearchString] = React.useState("");
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const [openPrintModal, setOpenPrintModal] = React.useState(false);
  const [openEditPrintModal, setOpenEditPrintModal] = React.useState(false);

  const [urlforPrint, setUrlforPrint] = React.useState(null);

  const [billCancellationModal, setBillCancellationModal] =
    React.useState(false);

  const [billId, setBillId] = React.useState(null);

  const [openBackdrop, setOpenBackdrop] = React.useState(false);

  const [options, setOptions] = React.useState([]);

  // -------------------------------------------------------
  // Date formatting
  // -------------------------------------------------------

  function getRequiredDateVal(inputDateVal) {
    if (!inputDateVal) return null;

    const objectDate = new Date(inputDateVal);

    if (Number.isNaN(objectDate.getTime())) return null;

    const day = String(objectDate.getDate()).padStart(2, "0");
    const month = String(objectDate.getMonth() + 1).padStart(2, "0");
    const year = objectDate.getFullYear();

    return `${year}-${month}-${day}`;
  }

  // -------------------------------------------------------
  // Populate bill table
  // -------------------------------------------------------

  const populateTable = (forPagination) => {
    const patientInfoObj = getValues("opdbillingSearch");

    const patientIdVal = patientInfoObj ? patientInfoObj.id : 0;

    const searchObj = {
      patientId: patientIdVal,
      fromDate: null,
      opdIpd: 0,
      page: !forPagination ? 0 : page,
      searchString: searchString,
      size: rowsPerPage,
      toDate: null,
    };

    let fromDateValue = getRequiredDateVal(getValues("FromDate"));
    let toDateValue = getRequiredDateVal(getValues("ToDate"));

    if (fromDateValue) {
      searchObj.fromDate = new Date(fromDateValue).toISOString();
    }

    if (toDateValue) {
      searchObj.toDate = new Date(toDateValue).toISOString();
    }

    getPatientBillList(searchObj)
      .then((response) => response.data)
      .then((res) => {
        if (forPagination) {
          setDataResult((prevData) => [...prevData, ...res.result]);
        } else {
          setPage(0);
          setDataResult(res.result || []);
        }

        setCount(res.count || 0);
      })
      .catch((error) => {
        console.error("Error fetching bill list:", error);
      });
  };

  // -------------------------------------------------------
  // Print modal handlers
  // -------------------------------------------------------

  const handleClosePrintModal = () => {
    setOpenPrintModal(false);
  };

  const handleCloseEditPrintModal = () => {
    setOpenEditPrintModal(false);
  };

  const handleOpenEditPrintModal = () => {
    setOpenEditPrintModal(false);
  };

  const handleOpenPrintModal = (billIdVal, type) => {
    setOpenBackdrop(true);

    if (type === "view") {
      getBillPrint(billIdVal)
        .then((response) => {
          setUrlforPrint(response);
          setOpenPrintModal(true);
        })
        .catch((error) => {
          console.error("Error fetching bill print:", error);
        })
        .finally(() => {
          setOpenBackdrop(false);
        });
    } else if (type === "edit") {
      getBillEditPrint(billIdVal)
        .then((response) => {
          setUrlforPrint(response);
          setOpenEditPrintModal(true);
        })
        .catch((error) => {
          console.error("Error fetching editable bill print:", error);
        })
        .finally(() => {
          setOpenBackdrop(false);
        });
    } else {
      setOpenBackdrop(false);
    }
  };

  // -------------------------------------------------------
  // Render table actions
  // -------------------------------------------------------

  const renderActions = (row, index) => {
    return (
      <div className="flex items-center justify-start gap-1 whitespace-nowrap">
        {userActions &&
          userActions.map((singleActionObj, actionIndex) => (
            <React.Fragment key={actionIndex}>
              {singleActionObj.action === "Print" &&
                singleActionObj.isAction === true && (
                  <Tooltip title="Print Bill Receipt">
                    <span>
                      <LocalPrintshopIcon
                        sx={{
                          cursor: row.IsCancelled ? "not-allowed" : "pointer",
                          color: row.IsCancelled ? "#71797E" : "#4B5563",
                          fontSize: 21,
                        }}
                        onClick={() => {
                          if (row.IsCancelled === false) {
                            handleOpenPrintModal(row.BillId, "view");
                          }
                        }}
                      />
                    </span>
                  </Tooltip>
                )}

              {singleActionObj.action === "Edit Print" &&
                singleActionObj.isAction === true && (
                  <Tooltip title="Edit Print">
                    <span>
                      <LocalPrintshopIcon
                        sx={{
                          cursor: row.IsCancelled ? "not-allowed" : "pointer",
                          color: row.IsCancelled ? "#71797E" : "#FA5332",
                          fontSize: 21,
                        }}
                        onClick={() => {
                          if (row.IsCancelled === false) {
                            handleOpenPrintModal(row.BillId, "edit");
                          }
                        }}
                      />
                    </span>
                  </Tooltip>
                )}

              {singleActionObj.action === "Cancel" &&
                singleActionObj.isAction === true && (
                  <Tooltip title="Cancel Bill">
                    <span>
                      <CancelOnIcon
                        title="Cancel Bill"
                        onClick={() => {
                          if (row.IsCancelled === false) {
                            setBillId(row.BillId);
                            setBillCancellationModal(true);
                          }
                        }}
                      />
                    </span>
                  </Tooltip>
                )}
            </React.Fragment>
          ))}
      </div>
    );
  };

  // -------------------------------------------------------
  // Initial data loading
  // -------------------------------------------------------

  React.useEffect(() => {
    const patientInfoObj = getValues("opdbillingSearch");

    const patientIdVal = patientInfoObj ? patientInfoObj.id : 0;

    const searchObj = {
      patientId: patientIdVal,
      fromDate: new Date(),
      opdIpd: 0,
      page: 0,
      searchString: searchString,
      size: rowsPerPage,
      toDate: new Date(),
    };

    getPatientBillList(searchObj)
      .then((response) => {
        setCount(response.data.count || 0);
        setDataResult(response.data.result || []);
      })
      .catch((error) => {
        console.error("Error fetching initial bill list:", error);
      });

    fetchUserActionsByMenuId(
      props.menuId ? props.menuId : location?.state?.menuId
    )
      .then((response) => response.data)
      .then((res) => {
        setUserActions(res.result || []);
      })
      .catch((error) => {
        console.error("Error fetching user actions:", error);
      });
  }, []);

  // -------------------------------------------------------
  // Patient search dropdown
  // -------------------------------------------------------

  const handleChange = (searchStringValue) => {
    const patientObjForBillSearch = {
      fromDate: null,
      opdIpd: 0,
      searchString: searchStringValue,
      toDate: null,
    };

    setSearchString(searchStringValue);

    let FromDateVal = getRequiredDateVal(getValues("FromDate"));
    let ToDateVal = getRequiredDateVal(getValues("ToDate"));

    if (FromDateVal) {
      patientObjForBillSearch.fromDate = new Date(
        FromDateVal
      ).toISOString();
    }

    if (ToDateVal) {
      patientObjForBillSearch.toDate = new Date(
        ToDateVal
      ).toISOString();
    }

    if (searchStringValue !== "") {
      searchPatientForBillList(patientObjForBillSearch)
        .then((response) => {
          setOptions(response.data.result || []);
        })
        .catch((error) => {
          console.error("Error searching patients:", error);
        });
    } else {
      setOptions([]);
    }
  };

  // -------------------------------------------------------
  // Render
  // -------------------------------------------------------

  return (
    <>
      <Modal
        open={props.open}
        onClose={() => props.setOpen(false)}
        aria-labelledby="bill-list-modal-title"
        aria-describedby="bill-list-modal-description"
      >
        <Box sx={ModalStyle}>
          {/* Modal Header */}
          <div className="flex items-center justify-between w-full mb-2">
            <h2
              id="bill-list-modal-title"
              className="text-base sm:text-lg font-semibold text-gray-700"
            >
              Bill Listing
            </h2>

            <CancelPresentationIconButton
              onClick={() => props.setOpen(false)}
              style={{
                padding: 5,
              }}
            />
          </div>

          {/* Main Content */}
          <div className="w-full min-w-0">
            <fieldset className="w-full min-w-0 border border-gray-300 rounded-md p-2 sm:p-3 md:p-4">
              <legend className="px-2 text-sm sm:text-base font-bold text-gray-700">
                Bill List - Search Filters
              </legend>

              {/* Responsive Search Filters */}
              <div
                className="
                  grid
                  grid-cols-1
                  sm:grid-cols-2
                  lg:grid-cols-5
                  gap-2
                  sm:gap-3
                  items-end
                  w-full
                  min-w-0
                "
              >
                {/* Patient Search */}
                <div className="w-full min-w-0 sm:col-span-2 lg:col-span-2">
                  <SearchDropdown
                    control={control}
                    name="opdbillingSearch"
                    dataArray={options}
                    searchIcon={true}
                    isClearable={true}
                    isSearchable={true}
                    placeholder="Search By Patient Name / MR.No. / Mobile No."
                    handleInputChange={handleChange}
                    inputRef={{
                      ...register("opdbillingSearch", {
                        onChange: (e) => {},
                      }),
                    }}
                  />
                </div>

                {/* From Date */}
                <div className="w-full min-w-0">
                  <DatePickerFieldNew
                    name="FromDate"
                    control={control}
                    label="From Date"
                    value={new Date()}
                    onChange={(newValue) => {
                      setValue("FromDate", newValue);
                    }}
                    inputFormat="dd-MM-yyyy"
                  />
                </div>

                {/* To Date */}
                <div className="w-full min-w-0">
                  <DatePickerFieldNew
                    name="ToDate"
                    control={control}
                    label="To Date"
                    value={new Date()}
                    onChange={(newValue) => {
                      setValue("ToDate", newValue);
                    }}
                    inputFormat="dd-MM-yyyy"
                  />
                </div>

                {/* Search Button */}
                <div className="w-full sm:col-span-2 lg:col-span-1 flex items-center">
                  <div className="w-full sm:w-auto">
                    <CommonButton
                      searchIcon
                      className="bg-customBlue text-white w-full sm:w-auto"
                      onClick={() => {
                        populateTable(false);
                      }}
                    />
                  </div>
                </div>
              </div>
            </fieldset>

            {/* Bill Table Section */}
            <div className="w-full min-w-0 mt-3 sm:mt-4">
              {dataResult.length > 0 ? (
                <div className="w-full min-w-0 overflow-x-auto">
                  <div className="min-w-0 w-full">
                    <CommonDynamicTablePaginationNew
                      dataResult={dataResult}
                      renderActions={renderActions}
                      populateTable={populateTable}
                      page={page}
                      setPage={setPage}
                      rowsPerPage={rowsPerPage}
                      count={count}
                      tableClass="rounded w-full min-w-0 h-auto max-h-[55dvh] overflow-auto"
                      removeHeaders={[
                        "BillId",
                        "IsCancelled",
                        "BillNo",
                        "PatientId",
                      ]}
                    />
                  </div>
                </div>
              ) : (
                <div className="flex items-center justify-center w-full min-h-[150px] text-center text-sm sm:text-base text-gray-500">
                  No Record Found
                </div>
              )}
            </div>
          </div>
        </Box>
      </Modal>

      {/* Backdrop */}
      <CommonBackDrop openBackdrop={openBackdrop} />

      {/* Bill Print Modal */}
      {openPrintModal && (
        <CommonPrintModal
          open={openPrintModal}
          setOpen={setOpenPrintModal}
          handleOpen={handleOpenPrintModal}
          handleClose={handleClosePrintModal}
          urlforPrint={urlforPrint}
        />
      )}

      {/* Edit Print Modal */}
      {openEditPrintModal && (
        <EmbedCommonPrintModal
          open={openEditPrintModal}
          setOpen={setOpenEditPrintModal}
          handleOpen={handleOpenEditPrintModal}
          handleClose={handleCloseEditPrintModal}
          urlforPrint={urlforPrint}
        />
      )}

      {/* Bill Cancellation Modal */}
      {billCancellationModal && (
        <ReasonForBillCancellation
          open={billCancellationModal}
          setOpen={setBillCancellationModal}
          billId={billId}
          populateTable={populateTable}
        />
      )}
    </>
  );
}

